import React, {FC} from 'react';
import {BaseTracker, BaseTrackerProps} from './BaseTracker';

export const TrackAppBanner: FC<
  React.PropsWithChildren<
    Pick<BaseTrackerProps, 'onImpressionTracked' | 'Comp'>
  >
> = props => {
  return <BaseTracker threshold={0.5} triggerOnce track={noop} {...props} />;
};

const noop = () => {};
